import React from 'react';
import { z } from 'zod';
import { COLOR_SCHEMA } from '../color';
import { FONT_FAMILY_SCHEMA, getFontFamily } from '../fonts';
import { getPadding, PADDING_SCHEMA } from '../padding';
export const HeadingPropsSchema = z.object({
    props: z
        .object({
        text: z.string().optional().nullable(),
        level: z.enum(['h1', 'h2', 'h3']).optional().nullable(),
    })
        .optional()
        .nullable(),
    style: z
        .object({
        color: COLOR_SCHEMA,
        backgroundColor: COLOR_SCHEMA,
        fontFamily: FONT_FAMILY_SCHEMA,
        fontWeight: z.enum(['bold', 'normal']).optional().nullable(),
        textAlign: z.enum(['left', 'center', 'right']).optional().nullable(),
        padding: PADDING_SCHEMA,
    })
        .optional()
        .nullable(),
});
export const HeadingPropsDefaults = {
    level: 'h2',
    text: '',
};
export function Heading({ props, style }) {
    var _e, _t, _y, _10, _11, _12;
    const level = (_e = props === null || props === void 0 ? void 0 : props.level) !== null && _e !== void 0 ? _e : HeadingPropsDefaults.level;
    const text = (_t = props === null || props === void 0 ? void 0 : props.text) !== null && _t !== void 0 ? _t : HeadingPropsDefaults.text;
    const hStyle = {
        color: (_y = style === null || style === void 0 ? void 0 : style.color) !== null && _y !== void 0 ? _y : undefined,
        backgroundColor: (_10 = style === null || style === void 0 ? void 0 : style.backgroundColor) !== null && _10 !== void 0 ? _10 : undefined,
        fontWeight: (_11 = style === null || style === void 0 ? void 0 : style.fontWeight) !== null && _11 !== void 0 ? _11 : 'bold',
        textAlign: (_12 = style === null || style === void 0 ? void 0 : style.textAlign) !== null && _12 !== void 0 ? _12 : undefined,
        margin: 0,
        fontFamily: getFontFamily(style === null || style === void 0 ? void 0 : style.fontFamily),
        fontSize: getFontSize(level),
        padding: getPadding(style === null || style === void 0 ? void 0 : style.padding),
    };
    switch (level) {
        case 'h1':
            return React.createElement("h1", { style: hStyle }, text);
        case 'h2':
            return React.createElement("h2", { style: hStyle }, text);
        case 'h3':
            return React.createElement("h3", { style: hStyle }, text);
    }
}
function getFontSize(level) {
    switch (level) {
        case 'h1':
            return 32;
        case 'h2':
            return 24;
        case 'h3':
            return 20;
    }
}
//# sourceMappingURL=Heading.js.map